// src/msalConfig.ts
//
// R-20: no hardcoded tenant/client/host fallbacks — all values come from the
// fail-closed config module (build-time REACT_APP_* variables).
// R-07: token cache is tab-scoped sessionStorage — never localStorage, and
//       cleared when the tab closes. See the cache block below for why not memory.
// R-08: sign-in requests identity only; Graph file/mail scopes are consented
//       incrementally by the features that need them (see tokenHelper.ts).

import { TENANT_ID, CLIENT_ID, FDD_API_CLIENT_ID, BASE_URL } from "./config";

const AUTHORITY_TENANT = `https://login.microsoftonline.com/${TENANT_ID}`;

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: AUTHORITY_TENANT,
    // MSAL redirect URI: use a dedicated callback route to process the auth response,
    // then RedirectHandler will navigate to /home. Keep Azure app registration in sync.
    redirectUri: `${BASE_URL}/auth/callback`,
    postLogoutRedirectUri: BASE_URL,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // MSAL blocks loginRedirect under "memoryStorage" (in_mem_redirect_unavailable):
    // the auth state has to survive the navigation to Entra and back. sessionStorage
    // is the closest option that still keeps tokens out of localStorage and drops
    // them when the tab closes. Switching to loginPopup would allow memory-only.
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// Sign-in: identity only (R-08).
export const loginRequest = {
  scopes: ["User.Read"],
};
export const silentRequest = {
  scopes: ["User.Read"],
};

// Incremental-consent Graph scopes, requested per feature (R-08).
export const pickerScopes: string[] = ["Files.ReadWrite.All"];
export const uploadScopes: string[] = ["Files.ReadWrite.All"];
export const mailScopes: string[] = ["Mail.Send"];

// FDD backend API — token audience for all /api calls (R-02).
export const apiRequest = {
  scopes: [`api://${FDD_API_CLIENT_ID}/access_as_user`],
};
